import { Box } from "components/common";
import ProductList from "./product-list";

import useFunctions from "../ts/useProductsFunctions";
import LeftSideBar from "./left-section";
import { ProductsWrapper } from "./index.styled";

export default function Products() {
  const { open } = useFunctions();
  return (
    <ProductsWrapper open={open}>
      <Box className="left">
        <LeftSideBar />
      </Box>
      <Box className="right">
        <ProductList />
      </Box>
    </ProductsWrapper>
  );
}
